<template>
  <span class="inline-flex align-items-center gap-sm">
    <select
      v-if="locations.length > 0"
      v-model="selectedLocationId"
      class="form-control input-sm"
      style="width: auto;"
      @change="emitBaseUrl"
      aria-label="Filter by location"
      data-cy="location-filter-select"
    >
      <option :value="null">All locations</option>
      <option v-for="location in locations" :key="location.id" :value="location.id">
        {{ location.name }}
      </option>
    </select>
    <button type="button" @click="toggleFilter" class="btn btn-default btn-compact">
      <i :class="showingArchived ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i>
      <span class="hidden-xs">{{ showingArchived ? 'Hide Archived' : 'Show Archived' }}</span>
    </button>
  </span>
</template>

<script>
export default {
  name: 'filter-archive-button',
  props: {
    initialType: {
      type: String,
      default: 'not_archived',
    },
    locations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showingArchived: false,
      selectedLocationId: null,
    };
  },
  methods: {
    buildBaseUrl() {
      const params = [];
      if (!this.showingArchived) {
        params.push('type=not_archived');
      }
      if (this.selectedLocationId) {
        params.push(`location_id=${this.selectedLocationId}`);
      }
      return params.length > 0 ? `/api/v1/paid_sessions?${params.join('&')}` : '/api/v1/paid_sessions';
    },
    emitBaseUrl() {
      this.$notificationManager.emit('update-search-base-url', {
        baseUrl: this.buildBaseUrl(),
      });
    },
    toggleFilter() {
      this.showingArchived = !this.showingArchived;
      this.emitBaseUrl();

      // Notify the user that the filter has changed
      const message = this.showingArchived ? 'Showing all sessions including archived' : 'Hiding archived sessions';
      this.$notificationManager.emit('show-toast', message, true);
    },
  },
};
</script>
